import React from 'react';
import { Column, Columns, Button } from '@codeparva/ui-components-library';

export const UpdateDetailsErrorScreen = ({
  setError,
  setLoading,
}: {
  setError: any;
  setLoading?: any;
}) => {
  return (
    <Columns className="payRentErrorContainer">
      <Column className="is-half">
        <img
          src="https://tfw-v11-assets.s3.us-east-1.amazonaws.com/demo-website/storage.png"
          alt="hasError"
          placeholder="blurred"
          loading="lazy"
        />
      </Column>
      <Column className="is-half">
        <p className="mainTitle">Something Went Wrong</p>
        <p className="subTitles">
          We couldn't update the details. Please try it again
        </p>
        <p className="note">
          Note : If the update process is still failing after 2 or 3 tries
          please try again in sometime.
        </p>
        <Button
          onClick={() => {
            setError(false);
            setLoading && setLoading(false);
          }}
          className="tryAgainButton"
        >
          Try Again
        </Button>
      </Column>
    </Columns>
  );
};
